import { weightUnitEnumFromOrdinal } from './weight-unit-enum-from-ordinal-service';
import { WeightUnit } from '../../../enums/weight-unit';

export const getWeightUnitEnum = (value) => {
  const defaultDimensionUnitEnum = WeightUnit.Ounces;
  if (!value) {
    return defaultDimensionUnitEnum;
  }

  const parsedValue = Number.parseFloat(value);
  if (Number.isInteger(parsedValue)) {
    return weightUnitEnumFromOrdinal(parsedValue);
  }

  return WeightUnit[value];
};
